import React, { useState, useEffect } from "react";
import styles from "./Form.module.css";
import copy from "../../../img/icons/copy.png"
import classNames from "classnames";
import { useFormik } from "formik";


const initialValues = {
  username: '',
  topic: '',
  organization: '',
  position: '',
  videoDeviceId: '',
  audioDeviceId: ''
}


export const Form = ({ roomName, onSubmit }) => {
  

  const [microphoneOptions, setMicrophoneOptions] = useState([]);
  const [cameraOptions, setCameraOptions] = useState([]);
  const [isInfo, setIsInfo] = useState('');
  const [copyButtonActive, setCopyButtonActive] = useState(false);
  const [loading, setLoading] = useState(false)


  const {values, handleChange, setFieldValue, handleSubmit} = useFormik({ initialValues, onSubmit })

  
  useEffect(() => {
    gettUserMedia();
  }, []);


  const gettUserMedia = async () => {
    setLoading(true)
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true})
    const mediaDevices = await navigator.mediaDevices.enumerateDevices();
    const microPhones = mediaDevices.filter(device => device.kind === 'audioinput')
    const cameras = mediaDevices.filter(device => device.kind === 'videoinput')
    setLoading(false)
    
    setMicrophoneOptions(microPhones)
    setCameraOptions(cameras)

    setFieldValue('audioDeviceId', microPhones[0]?.deviceId)
    setFieldValue('videoDeviceId', cameras[0]?.deviceId)
  }

  const copyButtonClick = () => {
    navigator.clipboard.writeText(roomName)
    setCopyButtonActive(true)
    setTimeout(() => {
      setCopyButtonActive(false)
    }, 1000);
  }



  return (
    <div className={styles.joinDialog}>
      
      <div className={styles.formBlock}>
      <h2>Для подключения к конференции укажите Ваши данные:</h2>
        <form onSubmit={handleSubmit}>
          <p>
            <div className={styles.labels}>Ссылка на конференцию:</div>
            <input
              className={`${styles.formControl} ${styles.item1}`}
              placeholder='Ссылка на конференцию'
              type="text"
              value={roomName}
              // onChange={handleChange}
              required
            />
            <div
              className={classNames(styles.copyButton, copyButtonActive && styles.active)}
              title='Скопировать ссылку'
              onClick={copyButtonClick}
            >
              <img src={copy} alt='o_O'/>
            </div>
          </p>
          {!window.location.pathname.toLowerCase().includes('session') &&
          <p>
            <div className={styles.labels}>Тема <br></br>конференции:</div>
            <input
              className={styles.formControl}
              placeholder="Тема конференции"
              name='topic'
              value={values.topic}
              onChange={handleChange}
              required
            />
          </p>}
          <p>
            <div className={styles.labels}>Ваше имя:</div>
            <input
              className={styles.formControl}
              placeholder="Ваше имя"
              name='username'
              value={values.username}
              onChange={handleChange}
              required
            />
          </p>
          <p>
            <div className={styles.labels}>Организация:</div>
            <input
              className={styles.formControl}
              placeholder='Организация'
              name='organization'
              value={values.organization}
              onChange={handleChange}
              required
            />
          </p>
          <p>
            <div className={styles.labels}>Должность:</div>
            <input
              className={styles.formControl}
              placeholder='Должность'
              name='position'
              value={values.position}
              onChange={handleChange}
              required
            />
          </p>
          <p>
            <div className={styles.labels}>Микрофон:</div>
            <select
              className={styles.formControl}
              name='audioDeviceId'
              value={values.audioDeviceId}
              onChange={handleChange}
            >
              <option value="" >Без микрофона</option>
              {microphoneOptions?.map((e) => (
                <option key={e.deviceId} value={e.deviceId}>
                  {e.label}
                </option>
              ))}
            </select>
          </p>
          <p>
            <div className={styles.labels}>Камера:</div>
            <select
              className={styles.formControl}
              name='videoDeviceId'
              value={values.videoDeviceId}
              onChange={handleChange}
            >
              <option value="">Без камеры</option>
              {cameraOptions?.map((e) => (
                <option key={e.deviceId} value={e.deviceId}>
                  {e.label}
                </option>
              ))}
            </select>
          </p>
          <p>
            <input
              className={styles.joinSubmit}
              name="commit"
              type="submit"
              value="подключиться"
              disabled={loading}
            />
          {!!isInfo && <div className={styles.info}>{isInfo}</div>}
          </p>
        </form>
      </div>
    </div>
  );
};
